import { HeroType } from "types/cms";
import Card from "./Card";
import Centered from "./Centered";

export default {
  [HeroType.card]: Card,
  [HeroType.centered]: Centered,
};
